import React from 'react';
import styled from 'styled-components';
import {
  MotifCard,
  MotifCardBody,
  MotifCardHeader,
  MotifCardImage,
} from '@ey-xd/motif-react';
import { unselectedStar, star, tooltip } from '../../../commonImage';
import OverflowTooltip from '../OverflowTooltip';

interface cardsProps {
  pragaphText?: string;
  appTitle: string;
  isFavourite?: boolean;
  onFavouriteClick: (e: any) => void;
  onCardClick: (e: any) => void;
  images?: string;
}

const Cards: React.FC<cardsProps> = ({
  pragaphText,
  appTitle,
  isFavourite,
  onFavouriteClick,
  onCardClick,
  images
}) => {
  const imageUrl = images ? require(`../../../assets/images/cards-images/${images}.jpeg`) : '';
  const getAppTileToolTip = (pragaphText: any) => (
    <>
      <div className='tooltip-info-spacer'></div>
      <span className='tooltip-info-description'>{pragaphText}</span>
      <br />
    </>
  );

  return (
    //@ts-ignore
    <StyleCard>
      <MotifCard className='app-card' style={{}}>
        <MotifCardImage onClick={onCardClick}>
          <img
            className='motif-card-image-src'
            alt='woman on glacier with EY in the center'
            src={imageUrl}
          />
        </MotifCardImage>
        <MotifCardHeader>
          <span className='motif-h6' onClick={onCardClick}>
            {appTitle}
          </span>
          <span className='favourite-className' onClick={onFavouriteClick}>
            <img
              className='starImage'
              src={isFavourite ? star : unselectedStar}
              alt={isFavourite ? 'favourite' : 'unselected favourite'}
            />
          </span>
        </MotifCardHeader>
        <MotifCardBody>
          <div className='motif-body cards-tooltip'>
            <span className='desc-text' onClick={onCardClick}>
              {pragaphText}
            </span>
            <OverflowTooltip
              className='tooltip-container'
              tooltipContent={getAppTileToolTip(pragaphText)}
              tooltipClassName='tooltip-placement'
              placement='bottom-start'
              trigger='click'>
              <img className='tooltip-image' src={tooltip} alt='tooltip'></img>
            </OverflowTooltip>
          </div>
        </MotifCardBody>
      </MotifCard>
    </StyleCard>
  );
};

const StyleCard = styled.div`
  .favourite-className {
    position: relative;
    padding: 2px;
    height: 30px;
    width: 30px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center; /* Vertically center the content */
  }
  .favourite-className:hover {
    position: relative;
    padding: 2px;
    background: #e6e6e9;
    height: 30px;
    width: 30px;
    text-align: center;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center; /* Vertically center the content */
  }

  .favourite-icon {
    font-size: 24px;
  }

  .tooltip-image {
    height: 30px;
    width: 30px;
    position: relative;
    top: 10px;
  }
  .cards-tooltip {
    display: flex;
    position: relative;
    top: -2px;
  }

  .motif-body {
    margin: 0px;
    max-width: 315px;
  }

  .motif-card {
    min-height: 255px;
  }

  .app-card {
    margin: 34px 5px 0px 7px;
    max-width: 97%;
    cursor: pointer;
  }

  .motif-card-image-src {
    max-height: 180px;
    width: 100%;
    padding: 10px;
  }

  .motif-card-header {
    padding-top: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 44px; /* Ensure header has a minimum height */
  }

  .motif-h6 {
    font-size: 14px;
    font-weight: 400;
    font-family: EYInterstate;
    display: flex;
    align-items: center;
  }

  span.overflow-wrapper:not(.allow-text-wrap),
  .overflow-content:not(.allow-text-wrap) {
    display: flex;
    white-space: unset;
    text-overflow: ellipsis;
    overflow: hidden;
    align-items: flex-end;
  }

  .desc-text {
    font-size: 13px;
    font-weight: 400;
    font-family: EYInterstate;
    width: 92%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3em;
    line-height: 1.5em;
    white-space: normal;
  }
`;
export default Cards;
